var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-label"},[_c('textInput',{attrs:{"placeholder":"Client Label","label":"Client Label","value":_vm.value,"rules":[(value) => !!value || 'Client label is required.']},on:{"change":function($event){[_vm.setConfigValue($event)]}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }